import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ModalSpaceState {
  useModalSpace: boolean;
}

const initialState: ModalSpaceState = {
  useModalSpace: true,
};

const modalSpaceSlice = createSlice({
  name: "modalSpace",
  initialState,
  reducers: {
    setUseModalSpace: (state, action: PayloadAction<boolean>) => {
      state.useModalSpace = action.payload;
    },
  },
});

export const { setUseModalSpace } = modalSpaceSlice.actions;
export default modalSpaceSlice.reducer;
